// Hide/show footer navigation on mobile
export function footerNav() {
  function toggleNav(footerHeading) {
    if (window.innerWidth <= 768) {
      const nav = footerHeading.nextElementSibling;
      nav.classList.toggle("hidden");
      footerHeading.classList.toggle("opened");
    }
  }

  function handleResize() {
    const footerHeadings = document.querySelectorAll(".footer-nav-col-2a h5, .footer-nav-col-3a h5");
    footerHeadings.forEach((footerHeading) => {
      const nav = footerHeading.nextElementSibling;
      if (window.innerWidth > 768) {
        nav.classList.remove("hidden");
        footerHeading.classList.add("opened");
      } else {
        nav.classList.add("hidden");
        footerHeading.classList.remove("opened");
      }
    });
  }

  const col2footerHeading = document.querySelector(".footer-nav-col-2a h5");
  col2footerHeading?.addEventListener("click", () => toggleNav(col2footerHeading));

  const col3footerHeading = document.querySelector(".footer-nav-col-3a h5");
  col3footerHeading?.addEventListener("click", () => toggleNav(col3footerHeading));

  window.addEventListener("resize", handleResize);

  handleResize();
}